import React from 'react'
import { useTheme } from '@mui/material'
import BackButton from 'redesign/components/atoms/Buttons/BackButton'
import CloseButton from 'redesign/components/atoms/Buttons/CloseButton'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import HeaderLabel from 'redesign/components/molecules/HeaderLabel'
import { DrawerHeaderWrapper } from 'redesign/components/molecules/drawer-header-wrapper'
import Header from 'redesign/components/organisms/Header'
import AbsenceAcceptDetailsFooter from 'redesign/components/organisms/absence-accept-details-footer'
import AbsenceAcceptContent from '../../absence-accept-content'
import { useAcceptForm } from '../../absence-accept-details/use-accept-form'
import { Container } from './styles'
import type { AcceptAbsenceRequestContentProps } from './types'

const AcceptAbsenceRequestContent: React.FC<AcceptAbsenceRequestContentProps> = ({
  task,
  onAccept,
  isDrawer,
  onClose,
  timelineItems,
  onGoBack,
}) => {
  const {
    t,
    loading,
    diffDaysSwitchProps,
    absenceTypeSelectProps,
    onSubmit,
    showDiffDaysToggle,
    showSingleTypeField,
    taskCommentFieldProps,
    mirusCommentFieldProps,
    individualAbsenceTypeFieldsProps,
  } = useAcceptForm({
    onAccept,
    task,
  })
  const { palette } = useTheme()

  return (
    <DrawerHeaderWrapper
      header={
        <Header
          startContent={<BackButton onGoBack={onGoBack} />}
          middleContent={<HeaderLabel mainText={t('absencePlanner.taskbar.frontlinerTasks.title')} />}
          endContent={isDrawer && <CloseButton onClick={onClose} />}
        />
      }
      footer={loading ? undefined : <AbsenceAcceptDetailsFooter onSubmit={onSubmit} task={task} />}
      backgroundColor={palette.background.base}
    >
      <Container>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <AbsenceAcceptContent
            task={task}
            timelineItems={timelineItems}
            diffDaysSwitchProps={diffDaysSwitchProps}
            absenceTypeSelectProps={absenceTypeSelectProps}
            showDiffDaysToggle={showDiffDaysToggle}
            showSingleTypeField={showSingleTypeField}
            taskCommentFieldProps={taskCommentFieldProps}
            mirusCommentFieldProps={mirusCommentFieldProps}
            individualAbsenceTypeFieldsProps={individualAbsenceTypeFieldsProps}
          />
        )}
      </Container>
    </DrawerHeaderWrapper>
  )
}

export default AcceptAbsenceRequestContent
